var _path, _rect, _g, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 693,
    viewBox: "0 0 47 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.451904 0H24.8352C36.9855 0 46.8352 9.84974 46.8352 22V670.248C46.8352 682.399 36.9854 692.248 24.8352 692.248H0.451904V0Z",
    fill: "url(#paint0_linear_3791_15537)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3791_15537",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 46,
    height: 692
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.125,
    width: 46,
    height: 691,
    fill: "url(#paint1_linear_3791_15537)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3791_15537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 51.1915,
    cy: 82.5166,
    rx: 51.1915,
    ry: 82.5166,
    transform: "matrix(-1 0 0 1 35.0005 -124.946)",
    fill: "#14257A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-90.5327 -42.4285C-90.5327 -7.9462 -81.8522 23.0423 -68.0718 45.2551C-54.2465 67.5404 -35.7732 80.3499 -16.191 80.3499C3.39125 80.3499 21.8646 67.5404 35.6899 45.2551C49.4703 23.0423 58.1508 -7.9462 58.1508 -42.4285C58.1508 -76.9108 49.4703 -107.899 35.6899 -130.112C21.8646 -152.397 3.39125 -165.207 -16.191 -165.207C-35.7732 -165.207 -54.2465 -152.397 -68.0718 -130.112C-81.8522 -107.899 -90.5327 -76.9108 -90.5327 -42.4285Z",
    stroke: "#050B2B",
    strokeWidth: 9.62672
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 51.1915,
    cy: 82.5166,
    rx: 51.1915,
    ry: 82.5166,
    transform: "matrix(-1 0 0 1 72.1335 444.377)",
    fill: "#14257A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-58.0402 526.846C-58.0402 561.738 -49.2619 593.223 -35.1849 615.914C-21.0875 638.638 -1.89662 652.25 18.927 652.25C39.7505 652.25 58.9414 638.638 73.0389 615.914C87.1159 593.223 95.8941 561.738 95.8941 526.846C95.8941 491.954 87.1159 460.47 73.0389 437.779C58.9414 415.055 39.7505 401.443 18.927 401.443C-1.89662 401.443 -21.0875 415.055 -35.1849 437.779C-49.2619 460.47 -58.0402 491.954 -58.0402 526.846Z",
    stroke: "#050B2B",
    strokeWidth: 4.37578
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8301 25.5992L27.5816 16.8476",
    stroke: "white",
    strokeWidth: 1.75031,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5815 25.5992L18.83 16.8476",
    stroke: "white",
    strokeWidth: 1.75031,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3791_15537",
    x1: 23.6435,
    y1: 0,
    x2: 23.6435,
    y2: 692.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3791_15537",
    x1: 24,
    y1: 0.125,
    x2: 24,
    y2: 691.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackground);
export default __webpack_public_path__ + "static/media/left_background.ad4113f7cd855c1e994eb9b82a507e37.svg";
export { ForwardRef as ReactComponent };